module.exports = __webpack_public_path__ + "media/images/icons/icon-flag-br-f1b2db59f0e968b4577403db5856b8b1.svg";